<template>
    <div class="xc-page reset xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <router-link :to="$config.adminPath + '/system/user'">系统设置</router-link>
                <a>房间设置</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form
                            class="xc-form"
                            name="search"
                            @submit.prevent="mix_search"
                        >
                            <div class="xc-form-inline">
                                <xc-form-item label="所属门店:">
                                    <select
                                        name="storeId"
                                        class="xc-select"
                                        v-model="mix_query.storeId"
                                        data-vv-as="所属名店"
                                    >
                                        <option value="">全部</option>
                                        <option
                                            v-for="(item,index) in stores"
                                            :value="item.storeId"
                                            selected
                                            :key="index"
                                        >{{ item.storeName }}</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item label="房间名称:">
                                    <input
                                        type="text"
                                        name="roomName"
                                        v-model="mix_query.roomName"
                                        class="xc-input"
                                        placeholder="请输入房间名称"
                                    >
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button
                                        type="submit"
                                        class="xc-btn xc-btn-primary"
                                    >查询
                                    </button>
                                    <button
                                        class="xc-btn xc-btn-default"
                                        type="button"
                                        @click="add"
                                    >添加
                                    </button>
                                </div>
                            </div>
                        </form>
                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th>序号</th>
                                    <th>所属门店</th>
                                    <th>房间名称</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,index) in list"
                                        :key="index"
                                    >
                                        <td>{{index+1}}</td>
                                        <td>{{item.storeName}}</td>
                                        <td>{{item.roomName}}</td>
                                        <td>
                                            <xc-btn-select
                                                title="管理"
                                            >
                                                 <template v-if="group.length">
                                                    <xc-btn-select-item
                                                        v-for="(obj,key) in group"
                                                        :key="key"
                                                        :title="obj.name"
                                                        @click.native="mix_action(obj,item,$event)"
                                                    ></xc-btn-select-item>
                                                </template>
                                            </xc-btn-select>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="20"
                                            class="xc-s-tac"
                                        >暂无数据
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination
                @change="pageChange"
                :page="mix_page"
                :total="mix_total"
                :size="mix_pageSize"
            />
        </div>
        <div class="xc-card">
            <!--添加/编辑-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName =='add' || modalName =='edit'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">{{ modalName =='add'?'添加':'编辑' }}</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName=null"
                            ></div>
                        </div>
                        <div class="xc-modal-body">
                            <form
                                class="xc-form"
                                name="add"
                                data-vv-scope="add"
                            >
                                <xc-form-item
                                    label="所属名店:"
                                    required
                                    :error="errors.first('storeId','add')"
                                >
                                    <select
                                        name="storeId"
                                        class="xc-select"
                                        v-model="fomData.storeId"
                                        v-validate="'required'"
                                        data-vv-as="所属名店"
                                        placeholder="请选择所属门店"
                                    >
                                        <option
                                            v-for="(item,index) in stores"
                                            :value="item.storeId"
                                            selected
                                            :key="index"
                                        >{{ item.storeName }}</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item
                                    label="房间名称:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="roomName"
                                        class="xc-input"
                                        v-model="fomData.roomName"
                                        v-validate="'required'"
                                        data-vv-as="房间名称"
                                        placeholder="请输入房间名称"
                                        :class="{'xc-input-error':errors.first('roomName','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("roomName","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="房间编码:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="roomCode"
                                        class="xc-input"
                                        v-validate="'required'"
                                        v-model="fomData.roomCode"
                                        data-vv-as="房间编码"
                                        placeholder="请输入房间编码"
                                        :class="{'xc-input-error':errors.first('roomCode','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("roomCode","add")}}
                                    </div>
                                </xc-form-item>
                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="modalName=null"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="addSubmit"
                                >保存
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--删除-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='delete'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">删除</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定删除该信息？
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="deleteSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import "@/libs/font-awesome"
import "@/libs/vee-validate"
import "@/libs/vue-select"
import "@/utils/form-format"
import houseApi from "@/api/systemHouse"
import myLayerImport from '@/libs/myLayer';

// ip格式化
import "@/utils/ip-format";

myLayerImport();

export default {
    name: 'systemKnowledge',
    mixins: [listMixin],
    data() {
        return {
            adminPath: this.$config.adminPath,
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'id',

            list: [],
            stores: [], //门店列表
            // 默认查询参数
            mix_query: {
                storeId: "",
                roomName: ""
            },
            group: [
                {
                    name: "编辑",
                    id: 0
                },
                {
                    name: "删除",
                    id: 1
                }
                
            ],
            modalName: null,  //弹窗名称,add表示添加\edit表示编辑
            current: null,  //当前表行
            fomData: {}  //表单数据
        }
    },
    created() {
        this.getStoreList()
    },
    methods: {
        getStoreList() {
            var _this = this;
            houseApi.getStoreSelectList().then(function (ret) {
                _this.stores = ret.data
            }).catch(function (error) {
                console.log(error)
            });
        },
        // 初始化数据
        initData() {
            var _this = this;
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
            }

            //请求列表数据
            houseApi.getRoomByPage({params:search}).then(function (ret) {
                _this.list = _this.mix_format(ret.data.list);
                _this.mix_total = ret.data.total;
                _this.mix_page = ret.data.pageNum;
                _this.mix_pageSize = ret.data.pageSize;
            }).catch(function (error) {
                console.log(error)
            });
        },
        // 更新分页
        pageChange: function (page, pageSize) {
            this.mix_page = page;
            this.mix_pageSize = pageSize;
            this.initData();
        },
        // 打开添加弹窗
        add() {
            this.modalName = "add";
            this.fomData = {}
        },
        // 操作单条数据
        action(...args) {
            const [action, item] = args;
            this.current = { ...item };
            this.fomData = { ...item }
            switch (action.name) {
                case "编辑":
                    this.modalName = "edit";
                    break;
                case "删除":
                    this.modalName = "delete";
                    break;
                default:
                    break;
            }
        },
        // 添加、编辑确定
        addSubmit () {
            var myForm = document.add;
            // 验证器命名空间
            const scope = 'add';
            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    const data = this.$formFormat(myForm);

                    if(this.modalName === "add"){
                        houseApi.addRoom(data).then(() => {
                            this.$message.success("添加成功");
                            this.modalName = null;
                            this.initData();
                        })
                    }else{
                        data.roomId = this.current.roomId;
                        houseApi.updateRoom(data).then(() => {
                            this.$message.success("修改成功");
                            this.modalName = null;
                            this.initData();
                        })
                    }
                } else {
                    return false;
                }

            })
        },
        // 删除确认
        deleteSubmit() {
            houseApi.deleteRoom(this.current.roomId).then(v => {
                this.$message.success(v.msg);
                this.modalName = null;
                this.initData()
            })
        },
    }
}
</script>

<style  lang="scss">
@import "../xc-ui/scss/variable";
.reset {
    form[name="reset"] {
        .xc-form-item-label {
            width: 80px;
        }
    }
}
.position-upload {
  position: relative;
}
.file-input {
  position: absolute;
  top: 0;
  min-height: 40px;
  opacity: 0;
}
.musicPreview{
    color: #507dde;
    cursor: pointer;
}
</style>

